import { HttpClient } from "@angular/common/http";
import { Component, OnInit, Renderer2, ViewChild } from "@angular/core";
import { AppData } from "../../helpers/app-data";
import {
  ModalNotifyComponent,
  ModalNotifyTypes,
} from "../modal-notify/modal-notify.component";
import { BaseServiceService } from "../../services/base-service.service";
import { DashboardService } from "../../services/dashboard.service";
import { DataTableDirective } from "angular-datatables";
import { Subject } from "rxjs";
import {
  fluentTooltip,
  provideFluentDesignSystem,
} from "@fluentui/web-components";
import {DomSanitizer} from '@angular/platform-browser';
import { parsearDataEjecucion } from "../../helpers/data-ejecucion";
import { lastValueFrom } from "rxjs";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";

declare var fabric: any;

@Component({
  selector: "app-auditoria-procesos",
  templateUrl: "./auditoria-procesos.component.html",
  styleUrl: "./auditoria-procesos.component.css"
})
export class AuditoriaProcesosComponent implements OnInit {
  @ViewChild(ModalNotifyComponent) modalNotifyComponent!: ModalNotifyComponent;

  botonProcesando = false;
  textoBotonProcesando = "Cargando...";
  dtTrigger: Subject<any> = new Subject<any>();
  dialogComponentVerProcesos: any;
  dialogComponentVerDiagramaProceso: any;
  modalDiagramaVisible: boolean = false;
  modalDashboardVisible: boolean = false;
  xmlContent: string = '';
  mostrarDiagrama: boolean = false;
  mostrarDashboard: boolean = false;
  idEjecucionProceso: number | any = null;
  idEjecucionProcesoTitle: number | any = null;
  NombreProceso: string | any = null;
  NombreProcesoTitle: string | any = null ;
  
  // Variables para el dashboard específico del proceso
  processDashboardData: any = null;
  
  getDataTableAuditoria: any = [
    "EjecucionProceso",
    "GetDataTableEjecucionProceso",
  ];

  @ViewChild(DataTableDirective, { static: false })
  dtElement: any;
  dtInstance?: DataTables.Api | any;

  dtOptions: DataTables.Settings = {};
  dtOptButtons: any = [];

  dtOptionsDetalleEjecucionProceso: DataTables.Settings = {
    pagingType: "full_numbers",
    pageLength: 5,
    serverSide: true,
    processing: true,
    searching: true,
    ordering: true,
    language: {
      url: "../../../assets/es-ES.json",
    },
    columnDefs: [
      {
        targets: 12,
        className: 'datos-ejecucion-column'
      }
    ],
    scrollX: true,
    lengthMenu: [5], 
  };
  getDataTableEjecucionProceso: string =
    "EjecucionProceso/GetDataTableEjecucionProceso";
  getDataTableDetalleEjecucionProceso: string =
    "EjecucionProceso/DetalleEjecucionProceso?IdEjecucion=";
  columnas = [
    { title: "ID", data: "Id", order: 'desc' }, 
    { title: "Nombre Proceso", data: "NombreProceso" },
    { title: "Versión Proceso", data: "VersionProceso" },
    { title: "Estado Proceso", data: "EstadoProceso" },
    { title: "Usuario Creacion", data: "UsuarioInicia" },
    { title: "Fecha Inicia", data: "FechaInicia" },
    { title: "Fecha Finaliza", data: "FechaFinaliza" },
    { title: "Tiempo de Ejecucion", data: "TiempoEjecucion" },
  ];
  IdProcessDetail: string | any = "";
  IsCancelProcess: boolean = false;
  dialogComponentEnviarAccionProceso: any;
  dialogComponentCancelarProceso: any;
  cancelProcessForm: FormGroup | any;
  viewObs: boolean = false;
  lastEvent: any;

  tooltipProperties = [
    { key: 'UsuarioFinaliza', label: 'Usuario Ejecución', type: 'text' },
    { key: 'FechaFinaliza', label: 'Fecha Ejecución', type: 'date' },
    { key: 'TiempoRespuesta', label: 'Tiempo Respuesta', type: 'text' },
    { key: 'FechaExpiraTarea', label: 'Fecha Vencimiento', type: 'date' }
  ];

  legendaColores = [
    { color: '#4CAF50', label: 'Finalizado' },
    { color: '#FFC107', label: 'Pendiente' },
    { color: '#9E9E9E', label: 'Fallido' },
    { color: '#F44336', label: 'Cancelado' }
  ];
  /* Datatable */

  constructor(
    private http: HttpClient,
    private baseService: BaseServiceService,
    private dashboardService: DashboardService,
    private renderer: Renderer2,
    private sanitizer: DomSanitizer,
    private _formBuilder:FormBuilder
  ) {}

  async ngOnInit(): Promise<void> {
    this.dtOptButtons.push(
      { "button-id": "btnVerProceso", "button-icon": "ms-Icon--TaskManager","button-tooltip": "Ver Proceso"  ,'conditional-data': [
      { key: 'field', value: 'NombreProceso' }
    ]},
    { "button-id": "btnDescargarExcel", "button-icon": "ms-Icon--ExcelDocument","button-tooltip": "Descargar Reporte"},
    { "button-id": "btnVerDiagramaProceso", "button-icon": "ms-Icon--RedEye","button-tooltip": "Ver Diagrama Proceso" ,'conditional-data': [
      { key: 'field', value: 'NombreProceso' }
    ]},
    { "button-id": "btnVerDashboard", "button-icon": "ms-Icon--BarChartVertical","button-tooltip": "Ver Dashboard del Proceso" ,'conditional-data': [
      { key: 'field', value: 'NombreProceso' }
    ]}
    );

    this.cancelProcessForm = this._formBuilder.group({
      Observacion: new FormControl('', [Validators.required, Validators.maxLength(1000)])
    });

 
    var DropdownHTMLElements = document.querySelectorAll(".ms-Dropdown");
    for (var i = 0; i < DropdownHTMLElements.length; ++i) {
      var Dropdown = new fabric["Dropdown"](DropdownHTMLElements[i]);
    }

    var DatePickerElements = document.querySelectorAll(".ms-DatePicker-holder");
    for (var i = 0; i < DatePickerElements.length; i++) {
      new fabric["DatePicker"](DatePickerElements[i]);
    }

    var SpinnerElements = document.querySelectorAll(".ms-Spinner");
    for (var i = 0; i < SpinnerElements.length; i++) {
      new fabric["Spinner"](SpinnerElements[i]);
    }
  }

 

  attachClickEvents(): void {

    const reinitButtons = document.querySelectorAll("#ReiniciarTarea");
    const cancelButtons = document.querySelectorAll("#CancelarTarea");
    const obsButtons = document.querySelectorAll("#ObservacionesTarea");

    reinitButtons.forEach((button) => {
      this.renderer.listen(button, "click", (event) => {
        this.IdProcessDetail = button.getAttribute("data-id");

        const dialogSendActionProcess = document.querySelector(".enviar-accion");
        this.dialogComponentEnviarAccionProceso = new fabric["Dialog"](dialogSendActionProcess);
        this.dialogComponentEnviarAccionProceso.open();
      });
    });

    cancelButtons.forEach((button) => {
      this.renderer.listen(button, "click", (event) => {
        this.IdProcessDetail = button.getAttribute("data-id");
        this.IsCancelProcess = true;
        this.viewObs = false;

        const dialogSendActionProcess = document.querySelector(".cancel-observation");
        this.dialogComponentCancelarProceso = new fabric["Dialog"](dialogSendActionProcess);
        this.dialogComponentCancelarProceso.open();
      });
    });

    obsButtons.forEach((button) => {
      this.renderer.listen(button, "click", (event) => {
        this.cancelProcessForm.controls['Observacion'].setValue(button.getAttribute("data-id"));
        this.viewObs = true;

        const dialogSendActionProcess = document.querySelector(".cancel-observation");
        this.dialogComponentCancelarProceso = new fabric["Dialog"](dialogSendActionProcess);
        this.dialogComponentCancelarProceso.open();
      });
    });
  }

  clearCancelForm()
  {
    this.cancelProcessForm.reset();
  }

  closeCancelModal()
  {
    this.cancelProcessForm.reset();
    this.dialogComponentCancelarProceso.close();
  }

  async enviarAccionProceso()
  {

    const response = await lastValueFrom(this.http.post<any>(AppData.API_URL+"EjecucionProceso/AccionProceso?IdEjecucionDetalle="+this.IdProcessDetail+"&IsCancel="+this.IsCancelProcess+'&Observacion='+(this.IsCancelProcess ? this.cancelProcessForm.get('Observacion')!.value : null), null));

    if (!response.Ok) {

      let mensajeError = "<ul>";
      response.ValidationErrors.forEach((error: any) => {
        mensajeError += `<li>${error}</li>`;
      });
      mensajeError += "</ul>";

      this.baseService.triggerShowModal(
        this.IsCancelProcess ? "Error al cacelar proceso" : "Error al reiniciar proceso",
        mensajeError,
        ModalNotifyTypes.Danger,
        false
      );
      
    } else {

      if(this.IsCancelProcess)
      {
        this.dialogComponentCancelarProceso.close();
      }
      else
      {
        this.dialogComponentEnviarAccionProceso.close();
      }

      this.baseService.triggerShowModal(
        this.IsCancelProcess ? "Proceso cacelado" : "Proceso retomado",
        this.IsCancelProcess ? "Proceso cacelado exitosamente" : "Proceso retomado exitosamente",
        ModalNotifyTypes.Success,
        false
      );

      this.abrirModalTareasEjecucionProcesos();
      this.reloadDataTable();
      
    }

  }

  async edit(userId: number) {
    try {
      await this.baseService.setIdSeleccionado(userId);
      this.baseService.abrirModalEditar();
    } catch (error) {
      console.error("Error al establecer el ID:", error);
    }
  }

  async delete(userId: number) {
    try {
      // Llamamos a triggerShowModal para abrir el modal de confirmación
      this.baseService.triggerShowModal(
        "Eliminar Grupo",
        "¿Seguro que desea eliminar el Grupo?",
        ModalNotifyTypes.Warning,
        true
      );

      this.modalNotifyComponent.actionConfirmed.subscribe(
        (confirmed: boolean) => {
          if (confirmed) {
            this.baseService
              .delete("GrupoUsuario/BorrarGrupo", userId)
              .then(() => {
                this.reloadDataTable();
                this.baseService.triggerShowModal(
                  "Grupo Eliminado",
                  "Grupo Eliminado Correctamente",
                  ModalNotifyTypes.Success,
                  false
                );
              });
          } else {
          }
        }
      );
    } catch (error: any) {
      this.baseService.triggerShowModal(
        "Error al enviar el formulario:",
        error,
        ModalNotifyTypes.Danger,
        false
      );
    }
  }

  reloadDataTable(): void {
    // this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
    //   dtInstance.ajax.reload(null, false);
    // });
    this.dtInstance.ajax.reload(undefined,false);
  }

  /* Fin Datatable */

  gridLoaded(event: any) {
    this.dtInstance = event["table"];
  }

  customClick(event: any, lastEvent: boolean = false) {
    try {
      if(lastEvent){
        event = this.lastEvent;
      }
      this.lastEvent = event;
      this.idEjecucionProceso = event["data-id"];
      this.NombreProceso = event["data-field"];
      
      switch (event["button-id"]) {
        case "btnVerProceso":
          this.abrirModalTareasEjecucionProcesos();
          this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            dtInstance.on("draw", () => {
              this.attachClickEvents(); 
            });
          });
          break;
        case "btnDescargarExcel":
          this.baseService.descargarReporte(this.idEjecucionProceso, "EjecucionProceso", "GenerarExcelDetallesEjecucion", "ReporteDetalleAuditoria");
          break;
        case "btnVerDiagramaProceso":
          this.idEjecucionProcesoTitle = event["data-id"];
          this.NombreProcesoTitle = event["data-field"];
          this.cargarDiagramaProceso();
          break;
        case "btnVerDashboard":
          this.idEjecucionProcesoTitle = event["data-id"];
          this.NombreProcesoTitle = event["data-field"];
          this.cargarDashboardProceso();
          break;
         
       
      }
    } catch (error) {
      console.error("Error al retornar evento datatable", error);
    }
  }
  
  async cargarDiagramaProceso() {
    try {
      this.mostrarDiagrama = false;
      this.modalDiagramaVisible = true;
      // Llamar a la API para obtener la configuración XML del proceso
      const headers = {
        'X-APIKey': AppData.API_KEY,
        'Authorization': 'Bearer ' + sessionStorage.getItem(AppData.localStorageToken)
      };

      const response = await lastValueFrom(
        this.http.get<any>(
          `${AppData.API_URL}EjecucionProceso/ObtenerViewEstadoProceso?idEjecucion=${this.idEjecucionProceso}`,
          // `${AppData.API_URL}Proceso/GetProcesoConfiguracion?Id=${this.idEjecucionProceso}`,
          { headers }
        )
      );

      if (response && response.Data && response.Data.length > 0 && response.Data[0].ConfiguracionProceso) {
        const xmlOriginal = response.Data[0].ConfiguracionProceso;
        const estadosElementos = response.Data;
        this.xmlContent = this.aplicarColoresAlXML(xmlOriginal, estadosElementos);

        this.mostrarDiagrama = true;
      } else {
        console.error('No se pudo obtener la configuración del proceso');
        this.baseService.triggerShowModal(
          "Error",
          "No se pudo cargar el diagrama del proceso",
          ModalNotifyTypes.Danger,
          false
        );
        this.cerrarModalDiagrama();
      }
    } catch (error) {
      console.error('Error al cargar diagrama:', error);
      this.baseService.triggerShowModal(
        "Error",
        "Error al cargar el diagrama del proceso",
        ModalNotifyTypes.Danger,
        false
      );
      this.cerrarModalDiagrama();

    }
  }

  cerrarModalDiagrama() {
    this.modalDiagramaVisible = false;
    this.mostrarDiagrama = false;
    this.xmlContent = '';
  }

  // Métodos para el Dashboard del Proceso
  async cargarDashboardProceso() {
    try {
      this.mostrarDashboard = false;
      this.modalDashboardVisible = true;
      
      // Cargar los datos del dashboard específico del proceso usando el nuevo endpoint
      this.dashboardService.getProcessSpecificMetrics(this.idEjecucionProceso).subscribe({
        next: (data) => {
          console.log('Process specific metrics received:', data);
          this.processDashboardData = data;
          this.mostrarDashboard = true;
        },
        error: (error) => {
          console.error('Error cargando dashboard del proceso:', error);
          this.modalNotifyComponent.show(
            "Error al cargar el dashboard del proceso",
            "No se pudo cargar la información del dashboard para este proceso",
            ModalNotifyTypes.Danger,
            false
          );
          this.cerrarModalDashboard();
        }
      });
    } catch (error) {
      console.error('Error al cargar dashboard del proceso:', error);
      this.modalNotifyComponent.show(
        "Error al cargar el dashboard del proceso",
        "No se pudo cargar la información del dashboard para este proceso",
        ModalNotifyTypes.Danger,
        false
      );
      this.cerrarModalDashboard();
    }
  }

  cerrarModalDashboard() {
    this.modalDashboardVisible = false;
    this.mostrarDashboard = false;
    this.processDashboardData = null;
  }
  // Función recursiva para mapear y organizar el contenido del tooltip
  mapObjectToHtml(obj: any, indent: number = 0): string {
    if (obj === null || obj === undefined || obj === '') {
      return `<div class="tooltip-content" style="margin-left: ${
        indent * 10
      }px;"><strong>Valor:</strong> null</div>`;
    }

    let html = "";
    const indentStyle = `style="margin-left: ${indent * 10}px;"`;

    for (const [key, value] of Object.entries(obj)) {
      const sanitizedKey = this.sanitizer.sanitize(1, key);
      if (typeof value === "object" && value !== null) {
        html += `<div ${indentStyle}><strong>${sanitizedKey}:</strong></div>`;
        html += this.mapObjectToHtml(value, indent + 1);
      } else {
        const sanitizedValue = value !== null && value !== undefined ? this.sanitizer.sanitize(1, value.toString()) : 'N/A';
        html += `<div ${indentStyle}><strong>${sanitizedKey}:</strong> ${ sanitizedValue } </div>`;
      }
    }
    

    return html;
  }

  async descargarReporteGeneral() {
    try {
      const response = await lastValueFrom(
        this.http.get(
          AppData.API_URL +
            `EjecucionProceso/GenerarReporte`,
          { responseType: "blob" }
        )
      );
      
      const url = window.URL.createObjectURL(response);
      const a = document.createElement("a");
      a.href = url;
      a.download = 'ReporteGeneral.xlsx';
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error descargando el documento", error);
    }
  }

  abrirModalTareasEjecucionProcesos() {

    $('#processId').html('Proceso ' + this.idEjecucionProceso + ' - ' + this.NombreProceso);

    if ($.fn.dataTable.isDataTable($("#datatableDetalleEjecucionProcesos"))) {
      $("#datatableDetalleEjecucionProcesos").DataTable().clear().destroy();
    }
    // const dialog = document.querySelector(".ver-procesos");
    // this.dialogComponentVerProcesos = new fabric["Dialog"](dialog);
    // this.dialogComponentVerProcesos.open();
    // let tooltipText;

    this.dtOptionsDetalleEjecucionProceso.ajax = async (
      dataTablesParameters: any,
      callback
    ) => {
      this.http
        .post<any>(
          AppData.API_URL + this.getDataTableDetalleEjecucionProceso + this.idEjecucionProceso,
          dataTablesParameters
        )
        .subscribe((resp) => {
          
          console.log('RESPUESTA DEL SERVIDOR', resp.Data.data);

          callback({
            draw: resp.Data.draw,
            recordsTotal: resp.Data.recordsTotal,
            recordsFiltered: resp.Data.recordsFiltered,
            data: resp.Data.data,
          });
        });
    };
    provideFluentDesignSystem().register(fluentTooltip());

    this.dtOptionsDetalleEjecucionProceso.columns = [
      { title: "Id", data: "Id" },
      { title: "Nombre Elemento", data: "NombreElemento" },
      { title: "Documentación", data: "Documentacion" },
      { title: "Tipo Elemento", data: "TipoElemento" },
      { title: "Fecha Inicia", data: "FechaInicia" },
      { title: "Fecha Finaliza", data: "FechaFinaliza" },
      { title: "Fecha Expiracion", data: "FechaExpiraTarea", defaultContent: "Sin vencimiento", render: (d: any) => d ?? "Sin vencimiento" },
      { title: "Tiempo de Ejecucion", data: "TiempoEjecucion" },
      { title: "Estado Ejecución", data: "EstadoEjecucion" },
      { title: "Usuario Inicia", data: "UsuarioInicia" },
      { title: "Usuario Finaliza", data: "UsuarioFinaliza" },
      { title: "Desviacion", data: "Desviacion" },
      {
        title: "Datos Ejecución",
        data: "Id",
        orderable: false,
        render: (data: any, type: any, full: any, row: any) => {

          if(full.DataEjecucion)
          {
            let datosejecucion = parsearDataEjecucion(full.DataEjecucion);
            return type === 'display'? '<div style="height: 5em; line-height: 1em; overflow-x: hidden; overflow-y: scroll; width: 100%; font-size: larger; word-wrap: break-word;">' + this.mapObjectToHtml(datosejecucion) +'</div>' : '';
          }
          else
          {
            return '';
          }
          

          
                    // Mapear las claves y valores del objeto a una cadena de texto organizada
                  //   let tooltipContent = this.mapObjectToHtml(datosejecucion);

                  //   return `
                  //      <div>
                  //       <button class="ms-CommandButton-button" type="button" id="btnTask-${full.Id}" data-id="${full.Id}">
                  //         <span class="ms-CommandButton-icon ms-fontColor-themePrimary"><i class="ms-Icon ms-Icon--View"></i></span>
                  //       </button>
                        
                  //       <fluent-tooltip anchor="btnTask-${full.Id}">
                  //         <div class="tooltip-content">
                  //           ${tooltipContent}
                  //         </div>
                  //       </fluent-tooltip>
                  //     </div>
          
                  // `;
        },
      },
      {
        title: "Opciones",
        data: "Id",
        orderable: false,
        render: (data: any, type: any, full: any, row: any) => {
          
          if(full.EstadoEjecucion == "Fallido")
          {

            if(full.TipoElemento != 'bpmn2:exclusiveGateway')
            {
               return type === 'display' ? `<button class="ms-CommandButton-button opt-button" data-id="${full.Id}" id="ReiniciarTarea">
                <span title="Reiniciar tarea" class="ms-CommandButton-icon ms-fontColor-themePrimary"><i class="ms-Icon ms-Icon--Processing"></i></span>
              </button>
              <button class="ms-CommandButton-button opt-button" data-id="${full.Id}" id="CancelarTarea">
                <span title="Cancelar tarea" class="ms-CommandButton-icon ms-fontColor-themePrimary"><i class="ms-Icon ms-Icon--Delete"></i></span>
              </button>` : '';
            }
            else
            {
              return type === 'display' ? `<button class="ms-CommandButton-button opt-button" data-id="${full.Id}" id="CancelarTarea">
                <span title="Cancelar tarea" class="ms-CommandButton-icon ms-fontColor-themePrimary"><i class="ms-Icon ms-Icon--Delete"></i></span>
              </button>` : '';
            }
                       
          }
          else if(full.EstadoEjecucion == "Cancelado")
          {

            return type === 'display' ? `<button class="ms-CommandButton-button opt-button" data-id="${full.Observacion}" id="ObservacionesTarea">
            <span title="Observación Cancelación" class="ms-CommandButton-icon ms-fontColor-themePrimary"><i class="ms-Icon ms-Icon--Comment"></i></span>
            </button>` : '';   

          }
          else
          {
            return '';
          }
        },
      },
    ];

    this.dtTrigger.next(null);
  }

  aplicarColoresAlXML(xml: string, estadosElementos: any[]): string {
    try {
      // Crear un parser para el XML
      const parser = new DOMParser();
      const xmlDoc = parser.parseFromString(xml, 'text/xml');
      
      // Definir colores según estado
      const coloresPorEstado = {
        'Finalizado': '#4CAF50', // Verde
        'Fallido': '#9E9E9E',    // Gris
        'Cancelado': '#F44336',  // Rojo
        'Pendiente': '#FFC107'   // Amarillo
      };
      
      estadosElementos.forEach((elemento: any) => {
        if (elemento.IdElemento && elemento.EstadoEjecucion) {
          const id = elemento.IdElemento;
          const estado = elemento.EstadoEjecucion;
          const color = coloresPorEstado[estado as keyof typeof coloresPorEstado];
          
          const elementosProceso = xmlDoc.querySelectorAll(`[id="${id}"]`);

          elementosProceso.forEach(elementoProceso => {
           this.tooltipProperties.forEach(prop => {
             if (prop.key === 'TiempoRespuesta') {
                let value: any;
                let fechaFinaliza: any;
                let fechaInicia = new Date(elemento["FechaInicia"]);
                if(elemento["FechaFinaliza"])
                {
                  fechaFinaliza = new Date(elemento["FechaFinaliza"]);
                }else{
                  fechaFinaliza = new Date(new Date().toLocaleString("en-US", {timeZone: "America/Bogota"}));
                }
                const tiempoRespuesta = Math.abs(fechaFinaliza.getTime() - fechaInicia.getTime()) / 1000; // Tiempo en segundos
                value = this.formatearTiempo(tiempoRespuesta);
                elementoProceso.setAttribute(prop.key, value);
                
              }else{
                const value = elemento[prop.key]; 
                if (value) {
                  elementoProceso.setAttribute(prop.key, value);
                }
              }

            });
          })

          if (color) {
            const shapes = xmlDoc.getElementsByTagName('bpmndi:BPMNShape');
            for (let i = 0; i < shapes.length; i++) {
              const shape = shapes[i];
              if (shape.getAttribute('bpmnElement') === id) {
                shape.setAttribute('fill', color);
                break;
              }
            }
          }
        }
      });

      // Serializar el XML modificado
      const serializer = new XMLSerializer();
      return serializer.serializeToString(xmlDoc);
      
    } catch (error) {
      console.error('Error al aplicar colores al XML:', error);
      return xml;
    }
  }
  private formatearTiempo(tiempoEnSegundos: number): string {
    const minutos = Math.floor(tiempoEnSegundos / 60);
    const horas = Math.floor(minutos / 60);
    const dias = Math.floor(horas / 24);
    
    if (dias > 0) {
      const horasRestantes = horas % 24;
      const minutosRestantes = minutos % 60;
      if (horasRestantes > 0 && minutosRestantes > 0) {
        return `${dias}d ${horasRestantes}h ${minutosRestantes}m`;
      } else if (horasRestantes > 0) {
        return `${dias}d ${horasRestantes}h`;
      } else {
        return `${dias}d`;
      }
    } else if (horas > 0) {
      const minutosRestantes = minutos % 60;
      return minutosRestantes > 0 ? `${horas}h ${minutosRestantes}m` : `${horas}h`;
    } else if (minutos > 0) {
      return `${minutos}m`;
    } else {
      return `${Math.floor(tiempoEnSegundos)}s`;
    }
  }

}
